import { TrashSimpleIcon } from "@phosphor-icons/react";

import { DrawerAndModal } from "../DrawerAndModal";
import { ICON_SIZE } from "@/config/constants";
import { useBoundStore } from "@/app/store";
import { useShallow } from "zustand/shallow";
import { Button } from "@heroui/react";

interface ProfileModalProps {
  externalState: {
    isOpen: boolean;
    onOpenChange: (isOpen: boolean) => void;
  };
  id: string;
  img?: string;
}

export function ManageViewImage({ externalState, id, img }: ProfileModalProps) {
  const deviceType = useBoundStore(useShallow((state) => state.device.type));

  return (
    <DrawerAndModal
      id={id}
      closeLabel="Close"
      confirmLabel={undefined}
      onConfirm={undefined}
      title="Avatar image"
      icon={<TrashSimpleIcon size={ICON_SIZE.md} />}
      externalState={externalState}
    >
      <div className="flex h-full w-full flex-col items-center justify-center transition-all duration-150">
        <img src={img} alt="Avatar" className="max-w-full rounded-xl" />
      </div>
      {deviceType === "mobile" && (
        <div className="flex gap-2 pt-2">
          <Button color="primary" fullWidth onPress={() => externalState.onOpenChange(false)}>
            Close
          </Button>
        </div>
      )}
    </DrawerAndModal>
  );
}
